/* eslint-disable @stylistic/semi */
// deno-lint-ignore-file no-window

import jq from 'https://esm.ext.archive.org/jquery@3.6.1'

// If jQuery _already_ got loaded previously, use that instead
// This avoids the "2 versions of jQuery" problem, and the
// "same version, but from 2 sources" problem (eg: from esm.archive.org and esm.ext.archive.org)
const $ = 'jQuery' in window && '$' in window ? window.$ : jq

// sadly needed for later `import()` like jquery.ui, etc.
window.jQuery = $
window.$ = $

export { $, $ as default }
